import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import NavigationItem from './NavigationItem';
import MenuEditorDnDItem from '../dnd/MenuEditorDnDItem';

type Props = {
  numberOfItems: number;
  exact?: boolean;
  href: string;
};

const StyledMenuEditorDnDItem = styled(MenuEditorDnDItem)`
  margin-inline-end: -8px;
  margin-inline-start: -8px;
`;

const ITEMS_WITH_NO_CATEGORY_NAVITEM_ID = 'ITEMS_WITH_NO_CATEGORY_NAVITEM_ID';

const NoCategoryNavItem = ({ numberOfItems, exact, href }: Props) => {
  return (
    <StyledMenuEditorDnDItem
      id={ITEMS_WITH_NO_CATEGORY_NAVITEM_ID}
      disabled={{
        draggable: true,
      }}
      data={{
        type: 'DND_NAVIGATION_NO_CATEGORY',
        shrinkOverlayTypes: ['DND_EDITOR_SINGLE_ITEM', 'DND_EDITOR_MULTIPLE_ITEMS'],
      }}
    >
      {({ over, active }) => (
        <NavigationItem
          label={<FormattedMessage id="menu.nonCategorised" />}
          numberOfItems={numberOfItems}
          exact={exact}
          href={href}
          dropActive={
            over?.id === ITEMS_WITH_NO_CATEGORY_NAVITEM_ID &&
            (active?.data.current?.type === 'DND_EDITOR_SINGLE_ITEM' ||
              active?.data.current?.type === 'DND_EDITOR_MULTIPLE_ITEMS')
          }
        />
      )}
    </StyledMenuEditorDnDItem>
  );
};

export default NoCategoryNavItem;
